<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Achizițiile proiectului" :checked="completed"></M3FormTitle>
                <p class="title"><strong>Te rugăm să bifezi tipurile de investiții vizate prin proiect</strong> (minim 1 maxim 3)</p>
                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form ref="formular">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            class="first-input"
                        >
                            <b-form-group class="checkboxes">
                                <b-form-checkbox-group
                                    v-model="selected"
                                    :options="options"
                                    name="flavour-2a"
                                    stacked
                                    :state="errors.length > 0 ? false : null"
                                    :disabled="completed"
                                    @click.native="checkCompleted()"
                                ></b-form-checkbox-group>
                            </b-form-group>
                        </validation-provider>
                        <div>
                            <p class="title mb-3"><b>Adresa Imobilului unde se va realiza investiția (dacă este cazul)</b></p>
                            <div>
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="1"
                                    content-cols-lg="11"
                                    label="Adresa"
                                >
                                    <b-form-input
                                        v-model="address"
                                        type="text"
                                        name="address"
                                        :readonly="completed"
                                        style="font-weight: bold; color: #767a95"
                                        @input="address = address.toUpperCase()"
                                        @click.native="checkCompleted()"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <p style="margin-top: 20px"><b>Atenție! Imobilul va trebui să îndeplinească cumulativ următoarele condiții:</b></p>

                            <div style="display: flex; flex-direction: column; font-size: small; justify-content: flex-start; margin-top: 10px">
                                <span style="display: list-item; margin-left: 20px">nu face obiectul unor litigii în curs de soluționare la instanțele judecătorești, cu privire la situația juridică</span>
                                <span style="display: list-item; margin-left: 20px">nu face obiectul revendicărilor potrivit unor legi speciale în materie sau deptului comun.</span>
                            </div>

                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm(completed)"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </b-form>
                </validation-observer>
            </div>
            <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
            <div class="flex mb-3 data-group">
                <img src="@/assets/images/M3/M3Sketch/warn-sign-big.png">
                <p class="title m-0"><strong>Atenție!</strong> Această secțiune modifică următorii pași. Vă rugăm să bifați exclusiv tipurile de achiziții propuse pentru proiect.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BFormInput} from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    export default {
        components: {
            BForm,
            BFormCheckboxGroup,
            BFormGroup,
            BFormCheckbox,
            BFormInput,
            M3FormTitle,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            acquisitions: null,
            location_address: null,
        },
        data() {
            return {
                options: [
                    { text: 'Proiectul propune construcții noi sau interventii la construcţii existente – construire/ modernizare/extindere/ consolidare', value: 'constructions' },
                    { text: 'Proiectul propune achiziția unui imobil  (Nu se permite achiziția facilităților de cazare / CAEN 5520 sau achiziția de sedii de birouri / alte activități destinate investițiilor imobiliare)', value: 'buildings' },
                    { text: 'Proiectul propune achiziția de echipamente, utilaje, intalații, mobilier, echipamente informatice, mijloace de transport, active necorporale', value: 'equipments' },
                ],
                selected: [],
                completed: null,
                data: null,
                address: null
            }
        },
        watch:{
            acquisitions: {
                handler: function() {
                    if(this.acquisitions !== null){
                        this.selected = this.acquisitions
                        if(this.selected.length > 0) {
                            this.completed = true
                            this.$emit('formComplete')
                        }
                    }
                },
                deep: false
            },
            location_address: {
                handler: function() {
                    if(this.location_address !== null){
                        this.address = this.location_address
                    }
                },
                deep: false
            },
        },
        mounted() {
            axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                .then( response => {

                    this.completed = JSON.parse(response.data).proiectulMeuAchizitiileProiectului;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                })
        },
        methods: {
            completeForm(event) {
                // event.preventDefault()
                if(!event) {
                    axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                        .then( response => {
                            let checks = JSON.parse(response.data);

                            checks.proiectulMeuAchizitiileProiectului = false;
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                                .then(()=>{
                                    this.$emit('formIncomplete')
                                })
                        })
                }
                else {
                    this.$refs.observer.validate().then((e) => {
                        if(!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else{
                            this.acquisitionsSend = {
                                acquisitions: this.selected,
                                location_address: this.address
                            }
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', this.acquisitionsSend)
                                .then((firstResponse) => {
                                    axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                                        .then( response => {
                                            let checks = JSON.parse(response.data);

                                            checks.proiectulMeuAchizitiileProiectului = true;
                                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                                                .then( () => {
                                                    this.$toast.success(firstResponse.data)
                                                    this.$emit('formComplete')
                                                })
                                        })
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }

                    })
                // this.$refs.formular.submit()
                }
            },
            checkCompleted() {

                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            }
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.flex{
    display: flex;
    align-items: flex-end;
}
.flex img{
    margin-right: 10px;
}
.title{
    font-size: 14px;
    color: #5b6276;
}
.checkboxes >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.checkboxes >>> .custom-checkbox{
    margin: 10px 0;
}
.form-group >>> legend{
    text-align: left;
    font-size: 14px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>